import { AiSearchApiResponse } from '../services/types'

export function extractTrackingInformation(response: AiSearchApiResponse) {
  const { session_id, run_id, content } = response

  // Transform hardFilters into a flat array of values, filtering out any falsy values
  const hardFilters = Object.values(content?.hardFilters ?? {})
    .flat()
    .filter(Boolean)

  const hardFilterCount = hardFilters.length ?? 0
  const softFilterCount = content?.softFilters?.length ?? 0

  const filterType =
    hardFilterCount && softFilterCount
      ? 'combined'
      : hardFilterCount
      ? 'hard'
      : softFilterCount
      ? 'soft'
      : undefined

  const filterCount = hardFilterCount + softFilterCount
  const softFilters = content?.softFilters ?? []
  const filtersConcatenated = [...hardFilters, ...softFilters].join('|')

  return {
    session_id,
    run_id,
    filterType,
    filterCount,
    filtersConcatenated,
  }
}
